import { configureStyle, registerCssSerializer, scheduleStyleIntent, VIEW_CLASS, lazyStyleIntent, lazyGlobalStyleIntent } from '@sail/engine';
import { plugins } from './plugins';
import { properties } from './properties';
function createCss() {
    // Create the serializer
    const serializer = registerCssSerializer('default', configureStyle(properties, plugins));
    // The returned value of `lazyStyleIntent` is not an actual Style.Intent.
    // Styles are not expanded into atomic styles during this stage. To mantain
    // compatibility with the previous system while we roll this out, we need to
    // cast to unknown.
    const css = (...args)=>lazyStyleIntent(...args);
    css.global = lazyGlobalStyleIntent;
    css.properties = serializer.properties;
    css.plugins = serializer.plugins;
    // Schedule any styles necessary for normalizing views
    scheduleStyleIntent(css.global({
        // https://jira.corp.stripe.com/browse/SAIL-3433
        [`@supports (-webkit-hyphens:none)`]: {
            [`select.${VIEW_CLASS}, select.sail-next-select-fix`]: {
                fontFamily: `'Helvetica Neue', sans-serif !important`
            }
        },
        [`.${VIEW_CLASS}, .${VIEW_CLASS}::before, .${VIEW_CLASS}::after`]: {
            boxSizing: 'border-box'
        },
        [`span.${VIEW_CLASS}`]: {
            display: 'inline'
        },
        [`fieldset.${VIEW_CLASS}`]: {
            border: 0,
            margin: 0,
            minWidth: 0,
            padding: 0
        },
        [`legend.${VIEW_CLASS}`]: {
            padding: 0
        },
        [`.${VIEW_CLASS} > option`]: {
            padding: 0
        }
    }));
    return css;
}
/**
 Creates a set of styles that can be applied to one or more views.
 *
 @see https://sail.stripe.me/apis/css
 */ export const css = createCss();
// eslint-disable-next-line @typescript-eslint/no-empty-function
function preserveReference(_value) {}
/**
 Ensure that APIs that expose the `css` prop reference the default `css`
 serializer method. This ensures that the serializer won't be omitted when
 a bundler eliminates dead code.
 */ export function usesCssSerializer(value) {
    preserveReference(css);
    return value;
}
export const external = (value)=>value;

//# sourceMappingURL=css.js.map